import { FormItemName } from '@src/framework/workbench/drawer/constants';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { IItems } from '../form.interface';

/**
 * 页脚专项。页脚设置需要隐藏的设置项。
 * @returns
 */
export const getFooterHideItems = (): IItems => {
    const { currentSlide } = getAppService().viewableServiceLayer.selectionService;
    const date = currentSlide?.children?.find(child => child.isDatePl);
    let isFixedDate = true;
    if (!date) {
        isFixedDate = false;
    }
    (date as IShapeModel)?.paragraphList?.forEach((para) => {
        para.textRuns?.forEach((run) => {
            if (run.fieldType) {
                isFixedDate = false;
            }
        });
    });
    return {
        [FormItemName.DATETIME_FIELD_TYPE_SELECT]: () => isFixedDate,
        [FormItemName.DATETIME_INPUT]: () => !isFixedDate,
    };
};

const getAppService = (): IPcEditorAppServices => AppServiceProvider.getInstance()
    .getAppServices() as IPcEditorAppServices;
